import React from 'react';
import './Styles/App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Components/Header';
import GeneralProtected from './Pages/GeneralProtected';
import Home from './Pages/Home';
import Login from './Pages/Login';
import GMFHome from './Pages/GMFHome';
// import AdminHome from "./Pages/AdminHome";
import ViewOfHCWs from './Pages/ViewOfHCWs';
// import ViewOfEmployees from "./Pages/ViewOfEmployees";
import ResetPassword from './Pages/ResetPassword';
import ChatComponent from './Pages/ChatComponent'; // Import the ChatComponent
import CreateGMFAccount from './Pages/CreateGMFAccount';
import CreateInstitutionAccount from './Pages/CreateInstitutionAccount';
import ChatOverview from './Pages/ChatOverview';

function App() {
    return (
        <div className="App">
            <Router>
                {/* Different version if we have different types of users logging in */}
                {/* <Header userRole={userRole} /> */}
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route exact path="/gmfhome" element={<GMFHome />} />
                    <Route
                        exact
                        path="/protected"
                        element={<GeneralProtected />}
                    />
                    <Route exact path="/login" element={<Login />} />
                    <Route path="/resetpassword" element={<ResetPassword />} />
                    <Route path="/viewofhcws" element={<ViewOfHCWs />} />
                    <Route path="/chat" element={<ChatComponent />} />
                    <Route
                        path="/create-gmf-account"
                        element={<CreateGMFAccount />}
                    />
                    <Route
                        path="/create-institution-account"
                        element={<CreateInstitutionAccount />}
                    />
                    <Route path="/chat-overview" element={<ChatOverview />} />
                </Routes>
            </Router>
        </div>
    );
}

export default App;
